import { useRef } from "react";

import Banner from "./Banner";
import JobInformation from "./JobInformation";
import FormSection from "./FormSection";

const JobDetails = () => {
  const applyFormRef = useRef(null);

  return (
    <>
      <div className="bg-white text-gray-800">
    
        <Banner
          config={{
            applyFormRef,
            title: "Python developer",
          }}
        />

        <div className="bg-white px-6 md:px-16 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">
            <div className="lg:col-span-2 space-y-12">
              <div>
                <h2 className="text-[32px] font-semibold text-[#212129] mb-6">
                  Job Summary
                </h2>

                <p className="text-[#212129] text-[18px] leading-8 mb-6">
                  We are looking for a passionate and self-motivated Python
                  Developer (Fresher) to join our development team in Chennai.
                  This is an exciting opportunity for recent graduates or
                  entry-level professionals to work in a collaborative
                  environment, gain hands-on experience in back-end development,
                  and contribute to real-world software projects.
                </p>

                <p className="text-[#212129] text-[18px] leading-8 mb-6">
                  As a Python Developer, you will be responsible for developing
                  and maintaining robust backend systems, applying
                  object-oriented programming principles, and working closely
                  with our cross-functional teams to design, develop, and
                  deliver high-quality software solutions.
                </p>

                <h3 className="text-[20px] font-semibold text-green-600 mb-1">
                  Key Responsibilities
                </h3>
                <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>
                    Write clean, efficient, and maintainable backend code using
                    Python.
                  </li>
                  <li>
                    Collaborate with front-end developers, designers, and
                    product managers to develop seamless web applications.
                  </li>
                  <li>
                    Apply Object-Oriented Programming (OOP) principles to ensure
                    scalable and modular application design.
                  </li>
                  <li>
                    Develop and integrate RESTful APIs and third-party services.
                  </li>
                  <li>
                    Work with relational and/or NoSQL databases for data storage
                    and retrieval.
                  </li>
                  <li>
                    Participate in code reviews and follow best practices for
                    coding standards and version control.
                  </li>
                  <li>
                    Identify bottlenecks and bugs, and devise solutions to
                    mitigate and address issues.
                  </li>
                  <li>
                    Learn and adapt to new tools, technologies, and development
                    methodologies as required.
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="text-[20px] font-semibold text-green-600 mb-1">
                  Required Qualifications
                </h3>
                <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>
                    Bachelor’s Degree in Computer Science, Information
                    Technology, Engineering, or a related field.
                  </li>
                  <li>
                    (B.Sc in Computer Science/IT, BCA, B.E/B.Tech, MCA
                    preferred)
                  </li>
                  <li>
                    Strong foundational knowledge of Python programming
                    language.
                  </li>
                  <li>
                    Understanding of Object-Oriented Programming (OOP) concepts.
                  </li>
                  <li>
                    Basic knowledge of web development and how backend services
                    function.
                  </li>
                  <li>
                    Familiarity with databases (e.g., MySQL, PostgreSQL, SQLite,
                    or MongoDB).
                  </li>
                  <li>
                    Exposure to Python frameworks like Django or Flask is a
                    plus.
                  </li>
                  <li>
                    Hands-on academic projects, internships, or personal coding
                    projects will be considered a strong advantage.
                  </li>
                  <li>Good understanding of Data Structures and Algorithms.</li>
                </ul>
              </div>

              <div>
                <h3 className="text-[20px] font-semibold text-green-600 mb-1">
                  Desired Skills
                </h3>
                <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>Familiarity with Python Modules and Packages.</li>
                  <li>
                    Knowledge of version control tools (e.g., Git/GitHub).
                  </li>
                  <li>Basic understanding of RESTful APIs and JSON.</li>
                  <li>Strong analytical and debugging skills.</li>
                  <li>
                    Effective communication skills and the ability to work
                    collaboratively in a team environment.
                  </li>
                  <li>
                    Willingness to learn, grow, and take ownership of assigned
                    tasks.
                  </li>
                </ul>
              </div>
            </div>
            <JobInformation />
          </div>
        </div>
      </div>

      <FormSection applyFormRef={applyFormRef} />
    </>
  );
};

export default JobDetails;
